<div
  ng2FileDrop
  [ngClass]="{
    'file-over': hasBaseDropZoneOver,
    'has-error': wrongFileTypeError
  }"
  (fileOver)="fileOverBase($event)"
  [uploader]="uploader"
  class="dropzone"
  (click)="triggerFileInput()"
  (onFileDrop)="updateValue($event)"
>
  @if (wrongFileTypeError) {
  <p
    class="wrong-filetype-error"
    i18n="
      Label | Alert when user drops a wrong filetype
      @@inputUploadWrongFileTypeLabel"
  >
    <mat-icon svgIcon="alert-xs"></mat-icon>
    Attention, seuls les fichiers au format suivant sont acceptés : {{ accept }}
  </p>
  }

  <mat-icon class="upload" svgIcon="files-md"></mat-icon>

  <p class="placeholder">{{ placeholder }}</p>
</div>

<input
  type="file"
  ng2FileSelect
  [uploader]="uploader"
  [accept]="accept"
  (onFileSelected)="updateValue($event)"
  hidden
  [multiple]="multiple"
  #fileinput
/>
